import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

import { environment } from '../../../src/environments/environment';
import { AuthenticationService } from '../authentication/authentication.service';
import { FtlQuote, FtlQuoteForCreate, FtlQuoteForUpdateComplete } from '../../app/models/ftlQuote';
import { DatData } from '../../app/models/datData';
import { LdiData } from '../../app/models/LdiData';

@Injectable({
  providedIn: 'root'
})
export class QuoteService {

  private _quote$ = new BehaviorSubject<FtlQuote>(new FtlQuote());

  constructor(
    private http: HttpClient,
    private authService: AuthenticationService
  ) { }

  get ftlQuote$(): Observable<FtlQuote> {
    return this._quote$.asObservable();
  }

  setFtlQuote(ftlQuote: FtlQuote) {
    this._quote$.next(ftlQuote);
  }

  getQuoteById(quoteId: number): Observable<any> {
    return this.http.get<any>(`${environment.traxFtlApiServerUrl}/ftlquotes/${quoteId}`);
  }

  postQuote(quote: FtlQuoteForCreate): Observable<any> {
    return this.http.post<Response>(`${environment.traxFtlApiServerUrl}/ftlquotes/create`, quote, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Headers': 'location',
        'Access-Control-Allow-Origin': '*'        
      }), observe: 'response'
    });
  }

  postQuoteForTender(quote: FtlQuoteForCreate): Observable<any> {
    return this.http.post<Response>(`${environment.traxFtlApiServerUrl}/ftlquotes/create-for-tender`, quote, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Headers': 'location',
        'Access-Control-Allow-Origin': '*'        
      }), observe: 'response'
    });
  }
  
  issueRate(ftlQuoteParam: FtlQuote): Observable<any> {
    return this.http.put<FtlQuote>(`${environment.traxFtlApiServerUrl}/ftlquotes/${ftlQuoteParam.id}/issuerate`, ftlQuoteParam.rate);
  }

  bookRate(quoteId: number): Observable<any> {
    return this.http.put<null>(`${environment.traxFtlApiServerUrl}/ftlquotes/${quoteId}/book`, null);
  }

  updateDetails(quoteId: number, ftlQuoteForUpdate: FtlQuoteForUpdateComplete): Observable<any> {
    return this.http.put<FtlQuoteForUpdateComplete>(`${environment.traxFtlApiServerUrl}/ftlquotes/${quoteId}/updatedetails`, ftlQuoteForUpdate);
  }

  complete(quoteId: number): Observable<any> {
    return this.http.put<null>(`${environment.traxFtlApiServerUrl}/ftlquotes/${quoteId}/complete`, null);
  }

  tender(quoteId: number): Observable<any> {
    return this.http.put<null>(`${environment.traxFtlApiServerUrl}/ftlquotes/${quoteId}/tender`, null);
  }

  getDatDataById(quoteId: number): Observable<DatData> {
    return this.http.get<any>(`${environment.traxFtlApiServerUrl}/ftlquotes/${quoteId}/datdata`);
  }

  getLdiDataById(quoteId: number): Observable<LdiData> {
    return this.http.get<any>(`${environment.traxFtlApiServerUrl}/ftlquotes/${quoteId}/ldidata`);
  }
}
